import { CheckoutSuccess } from "@/components/subscription/CheckoutSuccess";

export default function SubscriptionSuccess() {
  return <CheckoutSuccess />;
}
